module.exports = {
	"title": {
		"artist": "Ascolta {artistName} su Qobuz",
		"album": "Ascolta l'album {albumName} di {artistName} su Qobuz  ",
		"track": "Ascolta {trackName} di {artistName} su Qobuz  ",
		"playlist": "Ascolta la playlist {playlistName} di {ownerName} su Qobuz  ",
		"focus": "Leggi questa Panoramica su Qobuz"
	},
	"buttons": {
		"listen": "Ascoltare su Qobuz",
		"buy": "Comprare nello store",
		"download": "Scaricare Qobuz per Mac/Pc",
		"readmore": "Continuare a leggere",
		"showless": "Afficher moins",
		"showmore": "Vedere di più",
		"readfocus": "Leggere questa Panoramica su Qobuz",
		"seeSubscribes": "Vedere le offerte d'abbonamento "
	},
	"infos": {
		"trackCount": "{count} tracce",
		"diskCount": "{count} dischi",
		"duration": {
			"long": "{hours}h {minutes}m",
			"short": "{minutes}m {seconds}s"
		},
		"playlist": {
			"private": "Privata ",
			"public": "Pubblica"
		},
		"hires": "Alta risoluzione"
	},
	"share": {
		"twitter": {
			"track": "Ascolta {title} di {artist} su Qobuz ",
			"album": "Ascolta {title} di {artist} su Qobuz",
			"artist": "Ascolta {artist} su Qobuz ",
			"playlist": "Ascolta {playlist} di  {owner} su Qobuz  ",
			"focus": "Leggi questa Panoramica su Qobuz "
		},
		"mail": {
			"track": {
				"subject": "{title} di {artist} è disponibile su Qobuz!",
				"body": "Ascolta {title} di {artist} con Qobuz in alta risoluzione: {url}\n\nQobuz è il primo servizio di ascolto e download di musica in alta risoluzione.\nMaggiori informazioni e abbonamenti su Qobuz.com\n\n"
			},
			"album": {
				"subject": "{title} di {artist} è disponibile su Qobuz!",
				"body": "Ascolta {title} di {artist} con Qobuz in alta risoluzione: {url}\n\nQobuz è il primo servizio di ascolto e download di musica in alta risoluzione. \nMaggiori informazioni e abbonamenti su Qobuz.com\n\n"
			},
			"artist": {
				"subject": "{artist} è su Qobuz!",
				"body": "Ascolta {artist} con Qobuz in alta risoluzione: {url}\n\nQobuz è il primo servizio di ascolto e download di musica in alta risoluzione. \nMaggiori informazioni e abbonamenti su Qobuz.com\n\n"
			},
			"playlist": {
				"subject": "{playlist} di {owner} è disponibile su Qobuz!",
				"body": "Ascolta {playlist} di {owner} con Qobuz in alta risoluzione: {url}\n\nQobuz è il primo servizio di ascolto e download di musica in alta risoluzione.\nMaggiori informazioni e abbonamenti su Qobuz.com\n\n"
			},
			"focus": {
				"subject": "{title}",
				"body": "Da leggere {url}\n\nQobuz è il primo servizio di ascolto e download di musica in alta risoluzione. \nMaggiori informazioni e abbonamenti su Qobuz.com\n\n"
			}
		}
	},
	"tracklist": {
		"title": {
			"track": "Traccia",
			"album": "Titoli dell'album",
			"artist": "I migliori titoli",
			"artist_albums": "Album",
			"playlist": "Titoli della playlist"
		},
		"header": {
			"number": "#",
			"name": "Titolo",
			"album": "Album",
			"artist": "Artista",
			"time": "Durata",
			"label": "Etichetta"
		},
		"media_count": "CD {mediaNumber}",
		"noTracks": "Nessuna traccia disponibile"
	},
	"focus": {
		"from": "Di {author}",
		"albumOverlay": "- {releaseYear} - {genre}"
	},
	"playlist": {
		"from": "Par {author}"
	},
	"notifications": {
		"subscribe": "E' necessario abbonarsi a una delle offerte d'ascolto illimitato di Qobuz",
		"purchase": "Potete comprare questa canzone per ascoltarla ed importarla sulla vostra applicazione"
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/locales/it.json
// module id = 451
// module chunks = 0